/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Login API model
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as loginService from '../../services/login';
import LocalStorageService from '../../services/localStorage';

const localStorageService = LocalStorageService.getService();
const defaultModuleAccess = {
  groups: [],
  clients: [],
  instructions: [],
  organization: [],
  settings: [],
  policy: [],
  procedures: [],
  programs: [],
  businesslines: [],
  users: {},
  import_export: [],
  roles: [],
};

const loginModel = {
  username: localStorageService.getUserName(),
  userInfoAppLogs: {},
  userInfo: {},
  forceChangePassword: false,
  moduleAccessPermissions: defaultModuleAccess,
  setModuleWriteAccess: action((state, payload) => {
    state.moduleAccessPermissions = payload;

  }),
  removeUser: action((state, payload) => {
    state.username = {};
  }),
  setUserName: action((state, payload) => {
    state.username = payload;
  }),
  setForceChangePassword: action((state, payload) => {
    state.forceChangePassword = payload;
  }),
  setUserInfoAppLogs: action((state, payload) => {
    state.userInfoAppLogs = payload;
  }),
  setUserInfo: action((state, payload) => {
    state.userInfo = payload;
  }),
  authenticate: thunk(async (actions, payload) => {
    return await loginService.login(payload);
  }),
  resetPassword: thunk(async (actions, payload) => {
    return await loginService.resetPassword(payload);
  }),
  forgotPassword: thunk(async (actions, payload) => {
    return await loginService.forgotPassword(payload);
  }),
  changePassword: thunk(async (actions, payload) => {
    return await loginService.changePassword(payload);
  }),
  getUserInfo: thunk(async (actions) => {
    await loginService
      .getUserInfo()
      .then(function (response) {
        // Set user info state for app logs
        if(response && response.data && response.data.data && response.data.data.roles === null) {
          if(response.data && response.data.data && response.data.data.permissions && response.data.data.permissions.CHECKPOINT) {
            response.data.data.roles = response.data.data.permissions.CHECKPOINT;
          } else if(response.data && response.data.data && response.data.data.permissions && response.data.data.permissions.POLICIES) {
            response.data.data.roles = response.data.data.permissions.POLICIES;
          } else {
            response.data.data.roles = response.data.data.permissions.AUTO;
          }
        }
        const userInfoAppLogs = {
          userid: response.data.data.id,
          username: response.data.data.username,
          orgs_id: response.data.data.orgs_id,
          orgs_name: response.data.data.orgs_title,
        }
        actions.setUserName(userInfoAppLogs.username);
        actions.setUserInfoAppLogs(userInfoAppLogs);
        actions.setUserInfo(response.data.data);
        let modules = {
          policy: 1
        }
        if (response.data.data.modules) {
          modules = response.data.data.modules;
        }

        localStorageService.setUserInfo(JSON.stringify(response.data.data));
        localStorageService.setUserModuleAccess(JSON.stringify(modules));
        const moduleAccessPermissions = defaultModuleAccess;
        response?.data?.data?.roles?.access?.forEach((element) => {
          if (element.path === 'users') {
            moduleAccessPermissions[element.path] = element;
          } else {
            moduleAccessPermissions[element.path] = element.access_level;
          }
        });
        actions.setModuleWriteAccess(moduleAccessPermissions);

      })
      .catch(function (error) {
        // console.log('Error', error);
        actions.setUserInfo({});
      });
  }),

  ssoLogin: thunk(async (actions, payload) => {
    return await loginService.ssoLogin(payload);
  }),

  azureLogin: thunk(async (actions, payload) => {
    return await loginService.azureLogin(payload);
  }),

  logout: thunk(async (actions, payload = null) => {
    localStorageService.clearToken();
    if(!payload.is_sso_user || (payload.is_sso_user && payload.is_sso_user?.toUpperCase() == 'N')) {
      actions.setUserName('');
      actions.setUserInfo({});
    }
  }),
};

export default loginModel;
